export default __webpack_public_path__ + "static/media/raphael_stairs.9461c4e2.jpg";